import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex-col wrap" }
const _hoisted_2 = {
  class: "annon_content",
  style: {"width":"10000px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"30px"} }, " 【2023年6月24日（土）23時～24時（日本時間）】 ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, " システムメンテナンスの原因でシステムサービスがご利用頂けなくなります、ご注意ください。 ", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

import { ref, watch, computed, onMounted } from 'vue'

// onMounted(() => {
//   // location.reload()
// })
import { t } from '@/plugins/i18n'
import ServiceBtn from '@/components/common/serviceBtn.vue'
import MemberDialog from '@/components/common/MemberDialog.vue'
import PublicAuthModal from '@/views/authorized/PublicAuth/modal.vue'
import { useStore } from 'vuex'
import confirmDialog from '@/components/common/ConfirmDialog'
import { useRoute, useRouter } from 'vue-router'
import { useRtfix } from '@/store'
import { getCustomerNeedPopUpWindowByTypeApi, readPopUpWindowByType } from '@/apis/user'
import BcIntro from '@/components/common/bcIntro.vue'
import GlobalComp from '@/composables/comp/globalComp.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const store = useStore()
const route = useRoute()
const show = ref(
  !localStorage.__annoned__2 &&
  Date.now() < (Date.now() + 1000 * 3600 * 30) &&
  false // 若开启通告，删除此行
)
const close = () => (localStorage.__annoned__2 = true)

const memberDialog = computed(() => {
  return store.state.status.memberDialog
})

const regPath = (path: string) => {
  const reg = new RegExp('(' + path + ')')
  return reg.test(route.path as string)
}

watch(() => store.getters.isLogin, (newValue: any) => {
  if (!newValue) return
  getCustomerNeedPopUpWindowByTypeApi({
    type: 0
  }).then((res: any) => {
    if (res.data) {
      confirmDialog({
        title: `<span class="iconfont icon-tishi1" style="margin-right:4px;"></span>${t('请补充手机号信息')}`,
        text: t('为了更好的为您服务，我们建议您补充手机号信息'),
        htmlNode: true,
        okText: t('补充手机号'),
        cancelText: t('关闭'),
        closeOnClickModal: false
      }).then(() => {
        readPopUpWindowByType({
          type: 0
        })
        router.push(useRtfix('setupUser'))
      }).catch(() => {
        readPopUpWindowByType({
          type: 0
        })
      })
    }
  })
}, {
  immediate: true
})

return (_ctx: any,_cache: any) => {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (show.value)
      ? (_openBlock(), _createBlock(_component_el_alert, {
          key: 0,
          type: "warning",
          class: "annon",
          onClose: close
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (v) => {
                return _createElementVNode("span", {
                  key: v,
                  style: {"margin-right":"120px"}
                }, _hoisted_5)
              }), 64))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!regPath('/choseplat'))
      ? (_openBlock(), _createBlock(ServiceBtn, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(MemberDialog, {
      visible: _unref(memberDialog),
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(memberDialog) ? (memberDialog).value = $event : null))
    }, null, 8, ["visible"]),
    _createVNode(PublicAuthModal),
    _createVNode(GlobalComp),
    _createVNode(BcIntro),
    _createVNode(_component_router_view)
  ]))
}
}

})